import * as React from 'react';
import styled from 'styled-components'
import {mixinBtnMiddle, mixinResetBtnCss, mixinBtnBorder, mixinWithBtnPropsFn, IBtnDefaultProps} from "./btn_mixin";

interface IProps
    extends IBtnDefaultProps, React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
}

const BtnBorderMiddleDefault: React.FC<IProps> = (props) => {

    const { icon, widthSize, ...ButtonProps } = props;

    return (<button {...ButtonProps} />)

};

const BtnBorderMiddle = styled(BtnBorderMiddleDefault)`
    ${mixinResetBtnCss}
    ${mixinBtnMiddle}
    ${mixinBtnBorder}
    
    ${props => mixinWithBtnPropsFn(props)}
`;

export default BtnBorderMiddle;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/btn/btn_border_middle.tsx